/**
 * The /fimmetrics search-param schema -- the single source of truth for the
 * page's URL state.
 */
import { conversationExplorerSearchSchema } from 'features/modelOperations/conversationExplorer/explorerSearch'
import { z } from 'zod'

/**
 * Multi-value filter param: emits a non-empty array or undefined. A plain
 * value is accepted as a one-element set so deep links (`org=abc`) keep
 * working; invalid values fall back to unfiltered.
 */
const multiParam = <T extends z.ZodTypeAny>(value: T) =>
  z
    .union([value, z.array(value)])
    .optional()
    .transform((raw) => {
      if (raw === undefined) return undefined
      const values = (Array.isArray(raw) ? raw : [raw]) as z.infer<T>[]
      return values.length === 0 ? undefined : values
    })
    .catch(undefined)

export const metricsSearchSchema = z.object({
  org: multiParam(z.string()),
  site: multiParam(z.string()),
  excludeInternal: z.boolean().default(true).catch(true),
  excludeOrgLevel: z.boolean().default(false).catch(false),
  trend: z.enum(['rolling', 'daily']).default('rolling').catch('rolling'),
  ...conversationExplorerSearchSchema.shape,
})

export type MetricsSearch = z.infer<typeof metricsSearchSchema>
